var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtApproved = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 94,
    viewBox: "0 0 68 94",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8B8A6",
    d: "m0 10.3 46.742-9.292 12.829 63.97-46.742 9.293z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5AC94",
    d: "m23.375 5.657 23.361-4.645 12.83 63.97-23.362 4.645z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.077 10.697 46.738-9.296 1.292 6.397c.4 1.993-.91 3.932-2.912 4.33L5.72 19.994a3.704 3.704 0 0 1-4.35-2.9L.077 10.698z",
    fill: "#806953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.004 10.317 46.742 1.02l1.292 6.397c.4 1.993-.91 3.932-2.912 4.331L5.646 19.613a3.704 3.704 0 0 1-4.35-2.9L.004 10.317z",
    fill: "#C1986C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.555 64.952 12.817 74.23l-1.292-6.397c-.4-1.993.91-3.932 2.912-4.33l39.476-7.847a3.704 3.704 0 0 1 4.35 2.899l1.292 6.397z",
    fill: "#806953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.61 65.242 12.87 74.52l-1.292-6.397c-.4-1.993.91-3.932 2.912-4.331l39.477-7.846a3.704 3.704 0 0 1 4.35 2.899l1.292 6.397z",
    fill: "#C1986C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.868 28.148a1.247 1.247 0 0 1-1.474-.979l-3.003-14.968c-.145-.67.31-1.34.983-1.468a1.247 1.247 0 0 1 1.474.979l3.003 14.968c.146.67-.29 1.323-.983 1.468zM24.447 11.06c-.492.09-.801.58-.71 1.05L26.74 27.08a.896.896 0 0 0 1.056.706c.491-.09.8-.561.71-1.05l-3.004-14.969a.896.896 0 0 0-1.055-.706z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.61 23.907)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8A5F3D",
    cx: 3.021,
    cy: 3.008,
    rx: 3.021,
    ry: 3.008
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.077 2.79c.109.58-.255 1.142-.856 1.27-.6.126-1.146-.255-1.274-.853-.127-.598.255-1.141.856-1.268a1.07 1.07 0 0 1 1.274.852z",
    fill: "#424143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.258 4.24a1.247 1.247 0 0 1-1.474-.978c-.146-.67.309-1.341.982-1.468a1.247 1.247 0 0 1 1.475.979c.145.67-.292 1.322-.983 1.467zm-.419-2.12a.892.892 0 0 0-.71 1.051.896.896 0 0 0 1.056.707c.491-.09.8-.562.71-1.051a.896.896 0 0 0-1.056-.707z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.608 8.94)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8A5F3D",
    cx: 3.021,
    cy: 3.008,
    rx: 3.021,
    ry: 3.008
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.077 2.79a1.085 1.085 0 0 1-2.13.417 1.084 1.084 0 0 1 2.13-.417z",
    fill: "#424143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.276 4.222a1.247 1.247 0 0 1-1.474-.978c-.128-.67.31-1.341.983-1.468a1.247 1.247 0 0 1 1.474.978c.127.67-.31 1.341-.983 1.468zM2.84 2.12c-.491.09-.8.58-.71 1.051a.91.91 0 0 0 1.056.707c.491-.09.8-.58.71-1.051a.91.91 0 0 0-1.056-.707z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.382 10.552h45.646v64.91H14.382z",
    opacity: 0.3,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EAEE",
    d: "M14.146 10.389H59.79v64.91H14.146z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M19.66 27.568h17.472v1H19.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M19.66 28.565h17.472v1H19.66zM19.66 29.579h17.472v1H19.66zM19.66 30.594h17.472v1H19.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M19.66 31.59h17.472v1H19.66zM19.66 32.606h17.472v1H19.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M19.66 33.602h17.472v1H19.66zM19.66 34.617h17.472v1H19.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M19.66 35.614h17.472v1H19.66zM19.66 36.629h17.472v1H19.66zM19.66 37.643h17.472v1H19.66z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M39.244 27.568H53.53v1H39.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M39.244 28.565H53.53v1H39.244zM39.244 29.579H53.53v1H39.244zM39.244 30.594H53.53v1H39.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M39.244 31.59H53.53v1H39.244zM39.244 32.606H53.53v1H39.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M39.244 33.602H53.53v1H39.244zM39.244 34.617H53.53v1H39.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M39.244 35.614H53.53v1H39.244zM39.244 36.629H53.53v1H39.244zM39.244 37.643H53.53v1H39.244z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M19.66 39.89h34.125v1H19.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M19.66 40.887h34.125v1H19.66zM19.66 41.901h34.125v1H19.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M19.66 42.898h34.125v1H19.66zM19.66 43.913h34.125v1H19.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M19.66 44.91h34.125v1H19.66zM19.66 45.924h34.125v1H19.66zM19.66 46.94h34.125v1H19.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M19.66 47.936h34.125v1H19.66zM19.66 48.951h34.125v1H19.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M19.66 49.947h34.125v1H19.66z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F05A26",
    d: "M35.33 57.866h19.802v1H35.331z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M35.33 58.863h19.802v1H35.331z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M35.33 59.842h19.802v1H35.331z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M35.33 60.838h19.802v1H35.331z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M35.33 61.817h19.802v1H35.331z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD6E0",
    d: "M35.33 62.813h19.802v1H35.331z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#CFD6E0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.28 52.285h14.287v1H21.28zM21.28 53.3h14.287v1H21.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.907 44.91)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1E2969"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.005 10.836 17.021.362a2.255 2.255 0 0 1 3.094.634l5.497 8.318a2.234 2.234 0 0 1-.637 3.08L8.959 22.868a2.255 2.255 0 0 1-3.095-.634L.368 13.916c-.673-1.033-.4-2.41.637-3.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.182 15.12 20.896 2.229l3.887 5.891L5.069 21.012z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.435 7.574s-.983 1.45.4 1.92l5.879-.561 2.457 2.374 3.895.507s-1.984-3.17-3.294-4.983c-1.31-1.794-2.749-1.07-2.749-1.07l-6.588 1.813",
    fill: "#AD8A72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.506 6.867s-1.056 1.559.418 2.066l6.316-.616 2.657 2.555 4.186.562s-2.148-3.425-3.55-5.346c-1.4-1.92-2.948-1.142-2.948-1.142l-7.08 1.921",
    fill: "#C19A7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.704 6.16s-1.056 1.559.418 2.066l6.316-.616 2.657 2.555 4.186.562s-2.147-3.425-3.549-5.346c-1.401-1.92-2.948-1.141-2.948-1.141l-7.08 1.92",
    fill: "#D0A788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.474 30.008c-.255-.979-3.913-4.53-4.259-4.875-.018-.018-.036-.036-.054-.036-1.51-1.033-5.005-5.346-5.351-6.234-.328-.851-1.401-4.15-1.529-4.53 0-.018-.018-.054-.018-.072l-.4-2.845-.492-3.407a.43.43 0 0 1 .091-.326c.273-.345.91-.834 2.475.344.364.272 2.567 1.63 2.512 5.001 0 .091.018.182.073.254.455.634 2.712 3.787 4.313 3.969.055 0 .11 0 .146-.018.364-.091 2.111-.562 2.457-1.124 1.802-2.809-.364-6.596-.364-6.596-.31-.562-1.31-2.12-1.675-2.718a.392.392 0 0 0-.418-.181c-4.55.634-5.679.58-5.879.561-.018 0-.036 0-.054-.018C5.5 6.795 5.974 5.744 6.065 5.6c0-.018.018-.018.018-.037a.37.37 0 0 1 .255-.235c.983-.363 5.715-2.084 7.025-2.374 1.474-.308 2.13.018 3.185 1.558.91 1.323 2.13 2.791 2.457 3.172.055.072 1.038.815 1.11.851l4.787 2.863c.11.073.328.327.382.454.328.76 1.42 3.986.164 12.702 0 .073 0 .127.018.2.255.706 1.784 5.182 2.039 6.342.254 1.214-7.68 1.993-8.136 2.03h-.036c-.219.054-2.93.453-3.859-3.117z",
    fill: "#DDBDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.391 10.727s-.582 1.033-1.547.707l-.491-3.407s.036-.87.837-.254c.82.635 1.201 2.954 1.201 2.954zM8.358 5.562s.364-1.069 0-.924c-.364.127-2.42.453-2.33 1.124.073.652 2.33-.2 2.33-.2z",
    fill: "#FDE8DB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1E2969",
    cx: 12.799,
    cy: 11.941,
    rx: 5.715,
    ry: 5.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#323C76",
    cx: 13.254,
    cy: 11.434,
    rx: 3.858,
    ry: 3.842
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1E2969",
    cx: 13.927,
    cy: 10.745,
    rx: 2.184,
    ry: 2.175
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E4E5E5",
    d: "m45.865 74.525 14.206-4.185 1.023 3.44-14.206 4.186z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C760",
    d: "M68 94H49.982L45.54 78.343l16.872-4.965z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5B045",
    opacity: 0.3,
    d: "M59.082 94h-9.1L45.54 78.343l8.445-2.482z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.689 75.843c.163.561.746.87 1.31.706.564-.163.874-.743.71-1.304a1.048 1.048 0 0 0-1.31-.707 1.056 1.056 0 0 0-.71 1.305z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.925 75.408c.055.18.255.29.437.235a.355.355 0 0 0 .237-.435.357.357 0 0 0-.437-.235.355.355 0 0 0-.237.435z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.159 18.616.618 4.114h-1.092l-.054-.743h-.382l-.073.743h-1.129l.546-4.114h1.566zm-.565 2.646a52.406 52.406 0 0 1-.163-1.722c-.11.798-.182 1.36-.2 1.722h.363zM30.416 20.138h-1.073v-.38c0-.236-.019-.38-.037-.435-.018-.055-.073-.09-.145-.09-.073 0-.11.017-.128.072a1.481 1.481 0 0 0-.036.398v1.976c0 .18.018.308.036.362.018.054.073.09.146.09s.127-.036.164-.108c.018-.073.036-.2.036-.38v-.49h-.218v-.616h1.255v2.21h-.673l-.11-.29a.84.84 0 0 1-.272.29c-.11.073-.237.091-.4.091-.183 0-.346-.036-.51-.127-.164-.09-.273-.199-.364-.326a1.18 1.18 0 0 1-.146-.398 4.716 4.716 0 0 1-.036-.635v-1.214c0-.398.018-.67.073-.851.036-.182.163-.345.364-.49.2-.145.455-.217.782-.217.328 0 .583.072.783.2.2.126.346.29.4.452.073.181.091.435.091.761l.018.145zM30.835 18.616h.764c.51 0 .856.018 1.038.054a.681.681 0 0 1 .437.308c.109.164.164.417.164.762 0 .326-.037.525-.128.652-.09.127-.236.181-.473.2.218.054.346.126.437.217.073.09.109.163.145.235.037.073.019.272.019.616v1.088h-1.002v-1.36c0-.217-.018-.362-.054-.416-.037-.055-.128-.073-.273-.073v1.849h-1.074v-4.132zm1.074.707v.924c.127 0 .2-.018.255-.054.054-.037.072-.145.072-.327v-.217c0-.127-.018-.218-.072-.254-.055-.054-.128-.072-.255-.072zM33.638 18.616h1.784v.815h-.71v.78h.673v.779h-.673v.906h.782v.815h-1.856v-4.095zM35.822 18.616h1.784v.815h-.71v.78h.673v.779h-.673v.906h.782v.815h-1.856v-4.095zM41.3 18.616v4.114h-.946v-2.773l-.382 2.773h-.674l-.4-2.719v2.719h-.947v-4.114h1.384c.036.254.09.544.127.87l.146 1.05.254-1.92H41.3zM41.737 18.616h1.784v.815h-.71v.78h.673v.779h-.673v.906h.782v.815h-1.856zM46.305 18.616v4.114h-.946l-.564-1.867v1.867h-.892v-4.114h.892l.6 1.848v-1.848zM48.89 18.616v.815h-.637v3.28h-1.074v-3.28h-.637v-.815z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#C1272D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.336 68.467-.838-2.301.255-.181 1.802 1.649-.273.181-.473-.435-.528.344.218.616-.163.127zm-.146-1.033.382-.253-.728-.653.346.906zM23.755 67.543l-1.31-1.975.437-.29c.127-.09.218-.127.309-.109a.538.538 0 0 1 .237.09c.072.055.145.146.236.255.146.217.219.416.2.598a.489.489 0 0 1-.236.398l-.11.073.51.779-.273.181zm-.437-1.214.055-.036c.091-.073.146-.145.146-.254a.53.53 0 0 0-.11-.308.49.49 0 0 0-.127-.145c-.036-.036-.091-.054-.146-.072a.294.294 0 0 0-.163.054l-.091.072.436.69zM24.81 66.836l-1.31-1.975.437-.29c.128-.09.219-.127.31-.108a.538.538 0 0 1 .236.09c.073.055.146.145.237.254.145.217.218.417.2.598a.489.489 0 0 1-.237.399l-.109.072.51.78-.273.18zm-.436-1.214.055-.036c.09-.072.145-.145.145-.254a.53.53 0 0 0-.109-.308.49.49 0 0 0-.127-.145.366.366 0 0 0-.146-.072.294.294 0 0 0-.164.054l-.09.073.436.688zM25.885 66.13l-1.31-1.975.472-.309a.399.399 0 0 1 .255-.09c.073 0 .146.036.237.09.073.055.145.145.218.236.073.109.128.236.164.362a.61.61 0 0 1-.018.363l1.02.652-.31.218-.856-.598-.145.09.546.816-.273.145zm-.474-1.233.055-.036c.11-.072.164-.163.146-.253a.567.567 0 0 0-.11-.29.386.386 0 0 0-.182-.163c-.072-.037-.145 0-.254.072l-.091.054.436.616zM27.668 65.024c-.127.09-.273.11-.418.09a1 1 0 0 1-.474-.217 1.913 1.913 0 0 1-.436-.489 2.262 2.262 0 0 1-.292-.598c-.054-.2-.072-.362-.018-.507a.548.548 0 0 1 .255-.344c.127-.091.273-.11.419-.091a1 1 0 0 1 .473.217c.164.127.31.29.437.49.127.199.236.398.29.598.055.199.074.362.02.507a.6.6 0 0 1-.256.344zm-.182-.271c.128-.073.164-.218.11-.417a1.465 1.465 0 0 0-.274-.598 1.843 1.843 0 0 0-.436-.471c-.146-.11-.31-.127-.419-.055-.11.073-.164.218-.11.417.055.2.128.399.274.598.127.2.291.362.437.471.145.127.29.145.418.055zM28.833 64.19l-1.784-1.666.273-.182 1.384 1.287-.674-1.758.182-.127.874 2.266zM29.707 63.61l-1.31-1.974.8-.526.182.272-.546.362.364.544.455-.29.182.272-.455.29.4.598.583-.38.182.271zM30.762 62.922l-1.31-1.975.546-.362c.146-.09.291-.127.4-.11.128.02.273.092.4.2.128.109.274.272.42.471.127.2.218.381.29.58.055.181.073.345.055.508-.018.145-.11.271-.273.362l-.528.326zm.073-.453.2-.127c.11-.072.164-.145.182-.235.019-.09 0-.2-.036-.344a2.432 2.432 0 0 0-.218-.435 1.928 1.928 0 0 0-.292-.345.595.595 0 0 0-.29-.163c-.092-.018-.201.018-.328.09l-.164.11.946 1.45z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m20.77 66.184 9.628-6.36c.128-.073.146-.236.073-.363s-.236-.145-.364-.072l-.946.616a5.096 5.096 0 0 0-5.551.036 5.005 5.005 0 0 0-2.184 5.074l-.947.616c-.127.073-.145.236-.073.362.073.127.237.182.364.091zm3.13-5.69a4.559 4.559 0 0 1 4.787-.163L21.9 64.825a4.521 4.521 0 0 1 2.002-4.331zM32.146 62.47l-9.61 6.36c-.128.072-.146.235-.073.362s.237.145.364.073l1.001-.653a5.098 5.098 0 0 0 5.424-.127 5.083 5.083 0 0 0 2.22-4.929l1.001-.652c.128-.072.146-.235.073-.362s-.273-.145-.4-.073zm-3.204 5.58c-1.383.925-3.185.997-4.64.236l6.66-4.403a4.6 4.6 0 0 1-2.02 4.168z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtApproved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-approved.da9d5fabd92cba90ef0fb0d1cd0c0ea2.svg";